import Cleave from 'cleave.js';
import 'cleave.js/src/addons/phone-type-formatter.us.js';

export default {
    name: 'cleave',
    render(el) {
        return el('input', {
            attrs: {
                type: 'text',
                value: this.value, // Cleave.js will set this as initial value
            },
            on: {
                blur: this.onBlur,
            },
        });
    },
    props: {
        value: {
            default: null,
            required: true,
            validator(value) {
                return value === null || typeof value === 'string' || value instanceof String || typeof value === 'number';
            },
        },
        options: {
            type: Object,
            default: () => ({}),
        },
        raw: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            cleave: null,
            onValueChangedFn: null,
        };
    },
    mounted() {
        if (this.cleave) return;
        this.cleave = new Cleave(this.$el, this.getOptions(this.options));
    },
    methods: {
        /**
         * Inject our method in config options
         *
         * @param options Object
         */
        getOptions(options) {
            this.onValueChangedFn = options.onValueChanged;

            return Object.assign({}, options, {
                onValueChanged: this.onValueChanged,
            });
        },
        /**
         * Watch for value changed by cleave and notify parent component
         *
         * @param event
         */
        onValueChanged(event) {
            let value = this.raw ? event.target.rawValue : event.target.value;
            this.$emit('input', value);

            if (typeof this.onValueChangedFn === 'function') {
                this.onValueChangedFn.call(this, event);
            }
        },
        onBlur(event) {
            this.$emit('blur', this.value);
        },
    },
    watch: {
        /**
         * Watch for any changes in options and redraw
         *
         * @param newOptions Object
         */
        options: {
            deep: true,
            handler(newOptions) {
                this.cleave.destroy();
                this.cleave = new Cleave(this.$el, this.getOptions(newOptions));
                this.cleave.setRawValue(this.value);
            },
        },

        /**
         * Watch for changes from parent component and notify cleave instance
         *
         * @param newValue
         */
        value(newValue) {
            /* istanbul ignore if */
            if (!this.cleave) return;

            // when v-model is not masked (raw)
            if (this.raw && newValue === this.cleave.getRawValue()) return;
            //  when v-model is masked (NOT raw)
            if (!this.raw && newValue === this.$el.value) return;
            // Lastly set newValue
            this.cleave.setRawValue(newValue);
        },
    },
    /**
     * Free up memory
     */
    beforeDestroy() {
        if (!this.cleave) return;

        this.cleave.destroy();
        this.cleave = null;
        this.onValueChangedFn = null;
    },
};
